<template>
  <div class="register-page">
    <div class="slogan">
      <div>海量任务领不断，百万佣金待发放</div>
      <div>加入我们，一起来赚钱</div>
    </div>
    <div class="triangle-topleft"></div>
    <form class="form shadow">
      <div class="title">鲨鱼任务用户注册</div>
      <template v-if="systemInfo.use_phone_register">
        <!--手机号注册-->
        <van-field
          v-model="phone"
          center
          type="tel"
          label="手机号"
          placeholder="请输入手机号">
          <template slot="button">
            <van-button disabled size="small" v-show="!isTimeout">
              <van-count-down
                ref="countDown"
                :time="time"
                @finish="timeout">
                <template v-slot="timeData">
                  <span>{{ timeData.seconds }}S</span>
                </template>
              </van-count-down>
            </van-button>
            <van-button
              v-show="isTimeout"
              size="small"
              @click.prevent="sendSms">发送验证码</van-button>
          </template>
        </van-field>
        <van-field maxlength="6" v-model="code" type="digit" placeholder="请输入验证码" label="验证码" />
        <div class="item">
          <van-button type="primary" block @click="checkPhoneIsNew" :disabled="isLoading" >
            {{isLoading ? '注册中...' : '注册'}}
          </van-button>
        </div>
      </template>
      <template v-else>
        <!--账号密码注册-->
        <van-form @submit="onSubmit">
          <van-field
            v-model="username"
            name="用户名"
            label="用户名"
            placeholder="请输入用户名"
            :rules="[{ required: true, message: '请填写用户名' },
              { validator: usernameValidator, message: '请输入6~18位字母/数字' }]"
          />
          <van-field
            v-model="password"
            type="password"
            name="密码"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' },
              { validator: passwordValidator, message: '请输入6~16位密码，区分大小写' }]"
          />
          <van-field
            v-model="repeatPassword"
            type="password"
            name="重复密码"
            label="重复密码"
            placeholder="请再次输入密码"
            :rules="[{ required: true, message: '请再次输入密码' },
              { validator: repeatPasswordValidator, message: '两次输入密码不一致' }]"
          />
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit">
              提交
            </van-button>
          </div>
        </van-form>
      </template>
      <div class="skip-panel" v-if="showDownloadPageEntry">
        已有账号？<a :href="systemInfo.download_page">直接进入</a>
      </div>
    </form>
    <div class="tips">注册即代表你同意
      <router-link :to="{name: 'about.agreement'}">《服务协议》</router-link>
    和<router-link :to="{name: 'about.policy'}">《隐私政策》</router-link>
    </div>
  </div>
</template>

<script>
/**
 * 手机号登录
*/
import {
  Field,
  Button,
  Dialog,
  CountDown,
  Form,
  SubmitBar,
} from 'vant';
import AuthProxy from '@/proxies/auth';

export default {
  name: 'login-index',
  data() {
    return {
      isLoading: false,
      username: '',
      password: '',
      repeatPassword: '',
      phone: '',
      code: '',
      // 是否可从新获取验证码
      isTimeout: true,
      // 倒计时
      time: 60000,
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [CountDown.name]: CountDown,
    [Form.name]: Form,
    [SubmitBar.name]: SubmitBar,
  },
  computed: {
    systemInfo() {
      return this.$store.state.system.info;
    },
    // 手机号是否通过验证
    isPhoneValidate() {
      return /^(1[3,4,5,7,8,9])\d{9}$/.test(this.phone);
    },
    isCodeValidate() {
      return /^\d{6}$/.test(this.code);
    },
    showDownloadPageEntry() {
      return this.$storage.getItem('isRegistered') === 'yes';
    },
  },
  created() {
    const { inviter } = this.$route.query;
    if (!Number.isNaN(Number(inviter))) {
      this.$storage.setItem('inviter', inviter);
    }
  },
  methods: {
    usernameValidator(val) {
      return /^[A-Za-z0-9]{6,18}$/.test(val);
    },
    passwordValidator(val) {
      return /^.{6,16}$/.test(val);
    },
    repeatPasswordValidator(val) {
      return this.password === val;
    },
    async onSubmit() {
      const params = {
        username: this.username,
        password: this.password,
      };
      const inviter = this.$storage.getItem('inviter');
      if (!Number.isNaN(Number(inviter))) {
        params.inviter = inviter;
      }
      const res = await AuthProxy.register(params);
      if (res.success) {
        this.registerCallback();
      }
    },
    // 倒计时结束
    timeout() {
      this.isTimeout = true;
    },
    // 获取短信验证码
    async sendSms() {
      if (!this.isPhoneValidate) {
        this.$toast('请输入正确的手机号');
        return;
      }
      this.isTimeout = false;
      this.$refs.countDown.reset();
      const params = {
        phone: this.phone,
      };
      const res = await AuthProxy.sendSms(params);
      if (res.success) {
        this.$toast('发送成功');
      }
    },
    // 判断该手机号是否是新用户
    async checkPhoneIsNew() {
      if (!this.isPhoneValidate) {
        this.$toast('手机号不正确');
        return;
      }
      if (!this.isCodeValidate) {
        this.$toast('验证码不正确');
        return;
      }
      this.isLoading = true;
      const params = {
        phone: this.phone,
        code: this.code,
      };
      const res = await AuthProxy.checkPhoneIsNew(params);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      if (res.success) {
        if (res.data) {
          this.$toast('此手机号已被使用');
        } else {
          // 新用户，直接注册登录
          const inviter = this.$storage.getItem('inviter');
          if (!Number.isNaN(Number(inviter))) {
            params.inviter = inviter;
          }
          this.postPhoneLogin(params);
        }
      }
    },
    // 手机号登录
    async postPhoneLogin(data) {
      const res = await AuthProxy.phoneLogin(data);
      if (res.success) {
        this.registerCallback();
      }
    },
    registerCallback() {
      // 记录注册过，以便展示注册完后跳转的地址
      this.$storage.setItem('isRegistered', 'yes');
      this.$toast('注册成功');
      setTimeout(() => {
        window.location.href = this.systemInfo.download_page;
      }, 800);
    },
  },
};
</script>

<style lang="less" scoped>
.register-page {
  position: relative;
  min-height: 100vh;
  .skip-panel {
    text-align: center;
    font-size: 13px;
    padding-bottom: 10px;
    a {
      color: #619FFF!important;
    }
  }
  .tips {
    font-size: 12px;
    color: #666;
    text-align: center;
    width: 100%;
    margin-top: 100px;
    a {
      color: #619FFF!important;
    }
  }
  .slogan {
    position: absolute;
    color: #fff;
    margin: 10px;
  }
  .triangle-topleft {
    width: 0;
    height: 0;
    border-top: 50vh solid #1989fa;
    border-right: 100vw solid transparent;
  }
  .triangle-bottomleft {
    width: 0;
    height: 0;
    border-bottom: 50vh solid #1989fa;
    border-right: 100vw solid transparent;
  }
  .form{
    position: absolute;
    width: 92%;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    background-color: #fff;
    overflow: hidden;
    &.shadow {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .title {
      font-size: 18px;
      color: #444;
      text-align: center;
      padding: 18px 0;
      margin: 0;
    }
    .item {
      margin: 16px auto;
      padding: 0 20px;
      text-align: right;
      .right {
        float: right;
      }
      &:after {
        content: '';
        display: table;
        clear: both;
      }
      button {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        border-radius:3px;
        outline: none;
        cursor: pointer;
      }
      input {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        height: 40px;
        box-shadow: none;
        border: 1px solid #ccc;
      }
    }
  }
}
</style>
